import * as React from 'react';
import {
  Button,
  FileUpload,
  FormField,
  Input,
  Modal,
  ProgressBar,
  Select,
  Spinner
} from '@cloudscape-design/components';
import { DocumentContext } from '../../../context/documentContext';
// import { createParagraphs } from '../../../helpers/getFileData';
import { useContext, useEffect, useState, useMemo, useCallback } from 'react';
import { BaseRow, Importer, ImporterField } from 'react-csv-importer';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { DOCTYPE } from '../../../lib/models/interfaces';
import axios from 'axios';
import { UserContext } from '../../../context/authContext';
import { isEncrypted } from '../../../helpers/determineEncrypted';
import {
  detectFileType,
  getPDFPageCount
} from '../../../helpers/determineFileType';
import { useAlert } from '../../../context/alertContext';
import logger, { Logger } from '../../../helpers/Logger';
import { v4 as uuidv4 } from 'uuid';
import {
  createWSConnection,
  getDOCXPageCount,
  waitForMessage
} from './wsHelpers';
import { KoruLoading } from '../shared/KoruLoading';
import { xlsxToStructuredJson } from './convertSheetToTokens';
import { docxToTokenCount } from './convertDocxToTokens';
import { usePolicyContext } from '../../../context/policyContext';

interface Props {
  type: string | null;
  projectId: string;
  folderId: string;
  handleModalCancel?: (arg: boolean) => void;
}

type CreditCheckStatus = 'idle' | 'in-progress' | 'success' | 'error';
type FileProgressStatus = 'pending' | 'in-progress' | 'success' | 'error';

interface CreditCheckProgress {
  percent: number;
  status: CreditCheckStatus;
  message: string;
}

interface FileUploadProgressItem {
  progress: number;
  status: FileProgressStatus;
  message: string;
}

type UploadResult = {
  success: boolean;
  documentId?: string;
  error?: string;
};
type UploadProgressHandlers = {
  updateFileProgress?: (
    index: number,
    update: Partial<FileUploadProgressItem>
  ) => void;
  markFailure?: (index: number, message: string) => void;
};

type UploadDocxSupportedDocumentType =
  | DOCTYPE.prevRfp
  | DOCTYPE.rfp
  | DOCTYPE.policy_document
  | DOCTYPE.contract;

export const FileSelector = (props: Props) => {
  const { policies } = usePolicyContext();
  const [value, setValue] = useState<File[]>([]);
  const [selectedPolicy, setSelectedPolicy] = useState<{
    label: string;
    value: string;
  } | null>(null);
  const [docProcessing, setDocProcessing] = useState<boolean>(false);
  const {
    setFilesToUpload,
    setUploadProcessing,
    uploadProcessing,
    uploadFiles,
    qaOrigin,
    qaContact,
    setMainAlert,
    getAllDocs
  } = useContext(DocumentContext);
  const { auth, user, subscription, token } = useContext(UserContext);
  const { setAlert, setSubsAlert } = useAlert();
  const navigate = useNavigate();
  const [csvRowsArray, setCSVRowsArray] = useState<any[]>([]);
  const [fileError, setFileError] = useState<string[]>([]);
  const [uploadFileError, setUploadFileError] = useState<string[]>([]);
  const [uploadProgress, setUploadProgress] = useState<{
    processed: number;
    total: number;
  }>({ processed: 0, total: 0 });
  const [creditCheckProgress, setCreditCheckProgress] =
    useState<CreditCheckProgress>({
      percent: 0,
      status: 'idle',
      message: ''
    });
  const [fileUploadProgressList, setFileUploadProgressList] = useState<
    FileUploadProgressItem[]
  >([]);
  const [showUploadProgressPanel, setShowUploadProgressPanel] =
    useState<boolean>(false);
  const [allowUpload, setAllowUpload] = useState<boolean>(false);
  const [searchParams] = useSearchParams();
  const [determinedFileType, setDeterminedFileType] = useState<{
    mime: string;
    ext: string;
  } | null>(null);
  const [fileTypeArray, setFileTypeArray] = useState<
    ({ mime: string; ext: string } | null)[]
  >([]);
  const [showCoinsModal, setShowCoinsModal] = useState<{
    visible: boolean;
    type: string;
  }>({ visible: false, type: '' });
  const combinedFileErrors = useMemo(() => {
    const maxLength = Math.max(
      value.length,
      fileError.length,
      uploadFileError.length
    );
    return Array.from({ length: maxLength }, (_, index) => {
      return fileError[index] || uploadFileError[index] || '';
    });
  }, [value.length, fileError, uploadFileError]);
  const uploadProgressText = useMemo(() => {
    if (uploadProgress.total === 0) {
      return 'Processing Documents...';
    }
    return `Processing Documents... (${uploadProgress.processed}/${uploadProgress.total})`;
  }, [uploadProgress.processed, uploadProgress.total]);
  const policyOptions = useMemo(
    () =>
      policies.map((policy) => ({
        label: policy.policyName || 'Untitled Policy',
        value: policy._id || '',
        description: policy.version ? `Version ${policy.version}` : undefined
      })),
    [policies]
  );
  const resetPrevRfpProgress = useCallback(() => {
    setCreditCheckProgress({
      percent: 0,
      status: 'idle',
      message: ''
    });
    setFileUploadProgressList([]);
    setShowUploadProgressPanel(false);
  }, []);

  console.log('props type', props.type);
  const prevFile = searchParams.get('prevFile');
  const isQuestionnaire = props.type === DOCTYPE.questionnaire;
  const dropzoneAccept = useMemo(
    () =>
      isQuestionnaire
        ? [
            'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            '.xls',
            '.xlsx',
            'application/pdf',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            '.pdf',
            '.docx'
          ]
        : [
            'application/pdf',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            '.pdf',
            '.docx'
          ],
    [isQuestionnaire]
  );

  enum ProjectType {
    'workspace' = 'analysis',
    'information_request' = 'questionnaire',
    'information_request_library' = 'prev-rfp'
  }

  const handleInputChange = useCallback(
    async (files: File[]) => {
      setFileError([]);
      setUploadFileError([]);
      setUploadProgress({ processed: 0, total: 0 });
      resetPrevRfpProgress();

      if (props.type === DOCTYPE.questionnaire) {
        // get file type
        console.log('e target files', files);
        if (files.length === 0) {
          setFilesToUpload([]);
        }

        const fileType = await detectFileType(files[0]);
        setDeterminedFileType(fileType ?? null);
        console.log('file type in selector:', fileType);
        console.log('file type', fileType);
        setValue(files);
        // decide what type of processing docx or xls
        if (fileType?.mime === 'sheet') {
          // create a dcoument in mongo.
        }
        // else {
        //   setDocProcessing(true);

        //   const fileResults = await createParagraphs(
        //     files,
        //     props.projectId,
        //     props.folderId
        //   );
        //   if (fileResults !== null) {
        //     console.log('setting uploads', fileResults);
        //     setFilesToUpload(fileResults);
        //   }
        //   setDocProcessing(false);
        //   setAllowUpload(true);
        // }
      } else {
        // this is handling multiple files only pdf format and not encrypted
        console.log('e target files', files);
        if (files.length === 0) {
          setFilesToUpload([]);
          setValue([]);
          setFileError([]);
          setUploadFileError([]);
          resetPrevRfpProgress();

          return;
        }
        const isEncryptedArray = [];

        // const isEncryptedResult = await isEncrypted(files[0]);
        const fileTypeArrayLoc = [];

        for (const file of files) {
          // isEncryptedArray.push(await isEncrypted(file));
          const fileEncrypted = await isEncrypted(file);
          if (fileEncrypted) {
            isEncryptedArray.push('Encrypted');
          } else {
            isEncryptedArray.push('');
          }
          fileTypeArrayLoc.push(await detectFileType(file));
        }
        console.log('is encrypted result', isEncryptedArray);
        console.log('filetype array', fileTypeArrayLoc);
        setFileError(isEncryptedArray);
        setValue(files);
        setFileTypeArray(fileTypeArrayLoc);
        setDocProcessing(true);
        setDocProcessing(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      props.type,
      props.projectId,
      props.folderId,
      setFilesToUpload,
      setDeterminedFileType,
      setValue,
      setDocProcessing,
      setAllowUpload,
      setFileError,
      setFileTypeArray,
      // createParagraphs,
      detectFileType,
      isEncrypted,
      resetPrevRfpProgress
    ]
  );

  useEffect(() => {
    setUploadProcessing(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // this uploads RFP files both spreaksheet and docx / pdf.
  const handleRFPUpload = async (goToFile?: boolean) => {
    if (value.length === 0) return;
    setUploadProcessing(true);
    const createdDocumentIds: string[] = [];
    let ws: WebSocket | null = null;
    let connectionId: string | null = null;

    try {
      for (let i = 0; i < value.length; i++) {
        const currentFile = value[i];
        const typeOfFile = await detectFileType(currentFile);
        if (!typeOfFile) {
          throw new Error(`Unsupported file type for ${currentFile.name}`);
        }

        if (typeOfFile.mime === 'sheet') {
          console.log('Processing Xls sheet file fro RFP upload.');
          const docCreateResult = await axios.post(
            `${process.env.REACT_APP_KORU_API}/document?type=addNew`,
            {
              documentFileName: currentFile.name,
              documentType: DOCTYPE.rfp,
              project: props.projectId,
              folder: props.folderId,
              status: 'needs confirmation',
              fileExt: typeOfFile.ext,
              company_for: qaOrigin ?? '',
              company_contact_person: qaContact ?? ''
            },
            auth
          );
          const documentId = docCreateResult.data.result._id;
          const presignedUrl = await axios.post(
            `${process.env.REACT_APP_KORU_API}/get-presigned-url?type=uploadRFP`,
            {
              documentId: `${documentId}.${typeOfFile.ext}`
            },
            auth
          );
          await axios.put(presignedUrl.data.url, currentFile, {
            headers: {
              'Content-Type': currentFile.type || 'application/vnd.ms-excel'
            }
          });
          createdDocumentIds.push(documentId);
          continue;
        }

        if (typeOfFile.mime === 'pdf') {
          const uploadResult = await uploadPdfFile({
            file: currentFile,
            index: i,
            fileExt: typeOfFile.ext,
            documentType: DOCTYPE.rfp
          });
          if (!uploadResult.success) {
            throw new Error(uploadResult.error);
          }
          if (uploadResult.documentId) {
            createdDocumentIds.push(uploadResult.documentId);
          }
          continue;
        }

        if (typeOfFile.mime === 'docx') {
          if (!ws || !connectionId) {
            ws = await createWSConnection(token);
            const connectionIdData = await waitForMessage(
              ws,
              (msg) => msg.type === 'connectionId',
              300000
            );
            if (!connectionIdData?.connectionId) {
              throw new Error('Websocket connection failed');
            }
            connectionId = connectionIdData.connectionId;
          }
          const activeConnectionId = connectionId;
          if (!ws || !activeConnectionId) {
            throw new Error('Websocket connection failed');
          }
          const docxResult = await getDOCXPageCount(
            ws,
            currentFile,
            activeConnectionId,
            auth
          );
          const uploadResult = await uploadDocxFile({
            file: currentFile,
            index: i,
            fileExt: typeOfFile.ext,
            documentType: DOCTYPE.rfp,
            convertedFileKey: docxResult?.data?.key
          });
          if (!uploadResult.success) {
            throw new Error(uploadResult.error);
          }
          if (uploadResult.documentId) {
            createdDocumentIds.push(uploadResult.documentId);
          }
          continue;
        }

        throw new Error(`Unsupported file type for ${currentFile.name}`);
      }

      getAllDocs();
      if (goToFile && createdDocumentIds.length === 1) {
        navigate(
          `/app/rfp-upload?documentId=${createdDocumentIds[0]}&projectId=${props.projectId}`
        );
      } else {
        handleCancel();
      }
    } catch (e) {
      setMainAlert({
        showAlert: true,
        alertType: 'error',
        message: `File Upload Error - ${getUploadErrorMessage(e)}`
      });
    } finally {
      if (ws) {
        ws.close();
      }
      setUploadProcessing(false);
    }
  };

  const handleCancel = () => {
    setUploadFileError([]);
    setUploadProgress({ processed: 0, total: 0 });
    setSelectedPolicy(null);
    resetPrevRfpProgress();
    if (props.handleModalCancel) {
      setValue([]);
      props.handleModalCancel(false);
    } else {
      navigate(`/app/projects/${props.projectId}/folder/${props.folderId}`);
    }
  };

  const getUploadErrorMessage = (error: unknown): string => {
    if (axios.isAxiosError(error)) {
      const apiMessage =
        typeof error.response?.data?.message === 'string'
          ? error.response.data.message
          : null;
      return apiMessage ?? error.message;
    }
    if (error instanceof Error) {
      return error.message;
    }
    return 'Unknown error';
  };

  const uploadPdfFile = async ({
    file,
    index,
    fileExt,
    documentType,
    pageCountForCreditHold,
    progressHandlers
  }: {
    file: File;
    index: number;
    fileExt: string;
    documentType: DOCTYPE.prevRfp | DOCTYPE.rfp;
    pageCountForCreditHold?: number;
    progressHandlers?: UploadProgressHandlers;
  }): Promise<UploadResult> => {
    try {
      progressHandlers?.updateFileProgress?.(index, {
        status: 'in-progress',
        progress: 35,
        message: 'Creating document record'
      });
      const docCreateResult = await axios.post(
        `${process.env.REACT_APP_KORU_API}/document?type=addNew`,
        {
          documentFileName: file.name,
          documentType,
          project: props.projectId,
          folder: props.folderId,
          fileExt,
          ...(documentType === DOCTYPE.rfp
            ? {
                status: 'needs confirmation',
                company_for: qaOrigin ?? '',
                company_contact_person: qaContact ?? ''
              }
            : {})
        },
        auth
      );
      const documentId = docCreateResult.data.result._id;

      if (
        documentType === DOCTYPE.prevRfp &&
        typeof pageCountForCreditHold === 'number'
      ) {
        progressHandlers?.updateFileProgress?.(index, {
          status: 'in-progress',
          progress: 60,
          message: 'Applying credit hold'
        });
        await axios.post(
          `${process.env.REACT_APP_KORU_API}/credit?type=createCreditHold`,
          {
            type: DOCTYPE.prevRfp,
            numberOfPages: pageCountForCreditHold,
            documentId
          },
          auth
        );
      }

      progressHandlers?.updateFileProgress?.(index, {
        status: 'in-progress',
        progress: 80,
        message: 'Uploading PDF'
      });

      if (documentType === DOCTYPE.prevRfp || documentType === DOCTYPE.rfp) {
        console.log('uploading to extract questions');
        const presignedUrl = await axios.post(
          `${process.env.REACT_APP_KORU_API}/get-presigned-url?type=uploadRFPLibraryDocument&ext=${fileExt}`,
          {
            documentId: `${documentId}`
          },
          auth
        );
        await axios.put(presignedUrl.data.url, file, {
          headers: {
            'Content-Type': 'application/pdf'
          }
        });
      } else {
        const presignedUrl = await axios.post(
          `${process.env.REACT_APP_KORU_API}/get-presigned-url?type=uploadRFP`,
          {
            documentId: `${documentId}.${fileExt}`
          },
          auth
        );
        await axios.put(presignedUrl.data.url, file, {
          headers: {
            'Content-Type': 'application/pdf'
          }
        });
      }

      progressHandlers?.updateFileProgress?.(index, {
        status: 'success',
        progress: 100,
        message: 'Upload complete'
      });
      return { success: true, documentId };
    } catch (e) {
      logger.error(`Failed to upload PDF ${file.name}`, e);
      const message = `Failed to upload PDF - ${getUploadErrorMessage(e)}`;
      progressHandlers?.markFailure?.(index, message);
      return { success: false, error: message };
    }
  };

  const uploadDocxFile = async ({
    file,
    index,
    fileExt,
    documentType,
    tokenCountForCreditHold,
    convertedFileKey,
    documentCreateOverrides,
    progressHandlers
  }: {
    file: File;
    index: number;
    fileExt: string;
    documentType: UploadDocxSupportedDocumentType;
    tokenCountForCreditHold?: number;
    convertedFileKey?: string;
    documentCreateOverrides?: Record<string, unknown>;
    progressHandlers?: UploadProgressHandlers;
  }): Promise<UploadResult> => {
    try {
      progressHandlers?.updateFileProgress?.(index, {
        status: 'in-progress',
        progress: 35,
        message: 'Creating document record'
      });
      const docCreateResult = await axios.post(
        `${process.env.REACT_APP_KORU_API}/document?type=addNew`,
        {
          documentFileName: file.name,
          documentType,
          project: props.projectId,
          folder: props.folderId,
          fileExt,
          ...(documentType === DOCTYPE.rfp
            ? {
                status: 'processing',
                company_for: qaOrigin ?? '',
                company_contact_person: qaContact ?? ''
              }
            : {}),
          ...documentCreateOverrides
        },
        auth
      );
      const documentId = docCreateResult.data.result._id;
      console.log('documentId', documentId);
      if (
        documentType === DOCTYPE.prevRfp &&
        typeof tokenCountForCreditHold === 'number'
      ) {
        progressHandlers?.updateFileProgress?.(index, {
          status: 'in-progress',
          progress: 60,
          message: 'Applying credit hold'
        });
        await axios.post(
          `${process.env.REACT_APP_KORU_API}/credit?type=createCreditHold`,
          {
            type: DOCTYPE.prevRfp,
            numberOfTokensIn: tokenCountForCreditHold,
            documentId
          },
          auth
        );
      }

      if (!convertedFileKey) {
        throw new Error('Missing converted DOCX key');
      }
      progressHandlers?.updateFileProgress?.(index, {
        status: 'in-progress',
        progress: 80,
        message: 'Moving converted DOCX output'
      });
      await axios.post(
        `${process.env.REACT_APP_KORU_API}/document?type=moveConvertedFile`,
        {
          documentId: documentId,
          key: convertedFileKey,
          type: documentType
        },
        auth
      );

      progressHandlers?.updateFileProgress?.(index, {
        status: 'success',
        progress: 100,
        message: 'Upload complete'
      });
      return { success: true, documentId };
    } catch (e) {
      logger.error(`Failed to upload DOCX ${file.name}`, e);
      const message = `Failed to upload DOCX - ${getUploadErrorMessage(e)}`;
      progressHandlers?.markFailure?.(index, message);
      return { success: false, error: message };
    }
  };

  //TODO remove this it is a test for docx only
  const handleUploadFilePrev_RFP_All = async () => {
    if (value.length === 0) return;

    type IndexedFile = { file: File; index: number };
    type PDFReadyFile = IndexedFile & { pageCount: number };
    type DOCXReadyFile = IndexedFile & { tokenCount: number; key: string };

    const uploadErrors = Array.from({ length: value.length }, () => '');
    const failedFileNames: string[] = [];
    let successfulUploads = 0;
    let ws: WebSocket | null = null;

    const updateCreditProgress = (
      percent: number,
      status: CreditCheckStatus,
      message: string
    ) => {
      setCreditCheckProgress({ percent, status, message });
    };

    const updateFileProgress = (
      index: number,
      update: Partial<FileUploadProgressItem>
    ) => {
      setFileUploadProgressList((prev) =>
        prev.map((item, itemIndex) =>
          itemIndex === index ? { ...item, ...update } : item
        )
      );
    };

    const markFailure = (index: number, message: string) => {
      uploadErrors[index] = message;
      failedFileNames.push(value[index].name);
      updateFileProgress(index, {
        status: 'error',
        progress: 100,
        message
      });
    };

    try {
      setUploadProcessing(true);
      setUploadFileError([]);
      setShowUploadProgressPanel(true);
      setFileUploadProgressList(
        value.map(() => ({
          progress: 0,
          status: 'pending',
          message: 'Waiting for credit check'
        }))
      );
      updateCreditProgress(
        10,
        'in-progress',
        'Preparing files for credit check'
      );

      const docxFiles: IndexedFile[] = [];
      const pdfFiles: IndexedFile[] = [];
      const sheetFiles: IndexedFile[] = [];

      for (let i = 0; i < value.length; i++) {
        if (fileTypeArray[i]?.mime === 'docx') {
          docxFiles.push({ file: value[i], index: i });
          continue;
        }
        if (fileTypeArray[i]?.mime === 'pdf') {
          pdfFiles.push({ file: value[i], index: i });
          continue;
        }
        if (fileTypeArray[i]?.mime === 'sheet') {
          sheetFiles.push({ file: value[i], index: i });
          continue;
        }
        markFailure(i, 'Unsupported file type');
      }
      updateCreditProgress(25, 'in-progress', 'Calculating file metadata');

      const readyPDFs: PDFReadyFile[] = [];
      const readyDOCXs: DOCXReadyFile[] = [];
      let totalPageCount = 0;

      for (const pdfFile of pdfFiles) {
        try {
          updateFileProgress(pdfFile.index, {
            status: 'in-progress',
            progress: 10,
            message: 'Reading PDF for credit check'
          });
          const pageCount = await getPDFPageCount(pdfFile.file);
          totalPageCount += pageCount;
          readyPDFs.push({ ...pdfFile, pageCount });
          updateFileProgress(pdfFile.index, {
            status: 'pending',
            progress: 20,
            message: 'Ready to upload after credit check'
          });
        } catch (e) {
          logger.error(`Failed to prepare PDF ${pdfFile.file.name}`, e);
          markFailure(
            pdfFile.index,
            `Failed to read PDF - ${getUploadErrorMessage(e)}`
          );
        }
      }

      if (docxFiles.length > 0) {
        updateCreditProgress(
          40,
          'in-progress',
          'Converting DOCX files for credit check'
        );
        try {
          ws = await createWSConnection(token);
          const connectionIdData = await waitForMessage(
            ws,
            (msg) => {
              return msg.type === 'connectionId';
            },
            300000
          );
          if (!connectionIdData?.connectionId) {
            throw Error('Websocket connection failed');
          }

          for (const docxFile of docxFiles) {
            try {
              updateFileProgress(docxFile.index, {
                status: 'in-progress',
                progress: 10,
                message: 'Converting DOCX and calculating tokens'
              });
              const [docxResult, tokenCount] = await Promise.all([
                getDOCXPageCount(
                  ws,
                  docxFile.file,
                  connectionIdData.connectionId,
                  auth
                ),
                docxToTokenCount(docxFile.file)
              ]);
              if (!Number.isFinite(tokenCount) || tokenCount < 0) {
                throw Error('Invalid token count returned for DOCX');
              }
              readyDOCXs.push({
                ...docxFile,
                tokenCount,
                key: docxResult.data.key
              });
              updateFileProgress(docxFile.index, {
                status: 'pending',
                progress: 20,
                message: 'Ready to upload after credit check'
              });
            } catch (e) {
              logger.error(`Failed to prepare DOCX ${docxFile.file.name}`, e);
              markFailure(
                docxFile.index,
                `Failed to convert DOCX - ${getUploadErrorMessage(e)}`
              );
            }
          }
        } catch (e) {
          logger.error('DOCX websocket setup failed', e);
          const wsError = `Failed to process DOCX - ${getUploadErrorMessage(e)}`;
          for (const docxFile of docxFiles) {
            markFailure(docxFile.index, wsError);
          }
        }
      }
      updateCreditProgress(70, 'in-progress', 'Checking available credits');

      let enoughCredit = true;
      if (totalPageCount > 0) {
        const haveEnoughCredit = await axios.post(
          `${process.env.REACT_APP_KORU_API}/credit?type=verifyCreditHold`,
          {
            type: DOCTYPE.prevRfp,
            numberOfPages: totalPageCount
          },
          auth
        );
        console.log('credit result', haveEnoughCredit);
        enoughCredit =
          haveEnoughCredit?.data?.result?.message === 'Have Enough Credit';
      }

      if (!enoughCredit) {
        updateCreditProgress(
          100,
          'error',
          'Not enough credit to upload selected files'
        );
        setShowCoinsModal({ visible: true, type: 'BuyMore' });
        return;
      }
      updateCreditProgress(
        100,
        'success',
        'Credit check complete. Starting file uploads'
      );

      const uploadSheet = async (sheetFile: IndexedFile): Promise<boolean> => {
        try {
          updateFileProgress(sheetFile.index, {
            status: 'in-progress',
            progress: 35,
            message: 'Creating document record'
          });
          const ext = await detectFileType(sheetFile.file);
          const docCreateResult = await axios.post(
            `${process.env.REACT_APP_KORU_API}/document?type=addNew`,
            {
              documentFileName: sheetFile.file.name,
              documentType: DOCTYPE.prevRfp,
              project: props.projectId,
              folder: props.folderId,
              fileExt: ext?.ext
            },
            auth
          );
          updateFileProgress(sheetFile.index, {
            status: 'in-progress',
            progress: 55,
            message: 'Calculating spreadsheet tokens'
          });
          const ab = await sheetFile.file.arrayBuffer();
          const totalSheetTokens = xlsxToStructuredJson(Buffer.from(ab));
          logger.debug('total sheet tokens', totalSheetTokens);
          updateFileProgress(sheetFile.index, {
            status: 'in-progress',
            progress: 70,
            message: 'Applying credit hold'
          });
          await axios.post(
            `${process.env.REACT_APP_KORU_API}/credit?type=createCreditHold`,
            {
              type: DOCTYPE.prevRfp,
              numberOfTokensIn: totalSheetTokens,
              documentId: docCreateResult.data.result._id
            },
            auth
          );
          updateFileProgress(sheetFile.index, {
            status: 'in-progress',
            progress: 85,
            message: 'Uploading spreadsheet'
          });
          const presignedUrl = await axios.post(
            `${process.env.REACT_APP_KORU_API}/get-presigned-url?type=uploadRFPLibraryDocument&ext=${ext?.ext}`,
            {
              documentId: `${docCreateResult.data.result._id}`
            },
            auth
          );
          const putResult = await axios.put(
            presignedUrl.data.url,
            sheetFile.file,
            {
              headers: {
                'Content-Type': `${ext?.mime}`
              }
            }
          );
          console.log('put file result', putResult);
          updateFileProgress(sheetFile.index, {
            status: 'success',
            progress: 100,
            message: 'Upload complete'
          });
          return true;
        } catch (e) {
          logger.error(
            `Failed to upload spreadsheet ${sheetFile.file.name}`,
            e
          );
          markFailure(
            sheetFile.index,
            `Failed to upload spreadsheet - ${getUploadErrorMessage(e)}`
          );
          return false;
        }
      };

      const uploadTasks: Promise<UploadResult | boolean>[] = [
        ...readyPDFs.map((pdfFile) =>
          uploadPdfFile({
            file: pdfFile.file,
            index: pdfFile.index,
            fileExt: fileTypeArray[pdfFile.index]?.ext ?? 'pdf',
            documentType: DOCTYPE.prevRfp,
            pageCountForCreditHold: pdfFile.pageCount,
            progressHandlers: {
              updateFileProgress,
              markFailure
            }
          })
        ),
        ...readyDOCXs.map((docxFile) =>
          uploadDocxFile({
            file: docxFile.file,
            index: docxFile.index,
            fileExt: fileTypeArray[docxFile.index]?.ext ?? 'docx',
            documentType: DOCTYPE.prevRfp,
            tokenCountForCreditHold: docxFile.tokenCount,
            convertedFileKey: docxFile.key,
            progressHandlers: {
              updateFileProgress,
              markFailure
            }
          })
        ),
        ...sheetFiles.map((sheetFile) => uploadSheet(sheetFile))
      ];
      const uploadResults = await Promise.all(uploadTasks);
      successfulUploads = uploadResults.filter((result) =>
        typeof result === 'boolean' ? result : result.success
      ).length;

      if (successfulUploads > 0) {
        getAllDocs();
      }

      if (failedFileNames.length > 0) {
        const uniqueFailedFileNames = Array.from(new Set(failedFileNames));
        setUploadFileError(uploadErrors);
        setMainAlert({
          showAlert: true,
          alertType: 'error',
          message:
            successfulUploads > 0
              ? `${successfulUploads} file(s) uploaded. Failed file(s): ${uniqueFailedFileNames.join(
                  ', '
                )}`
              : `No files uploaded. Failed file(s): ${uniqueFailedFileNames.join(
                  ', '
                )}`
        });
        return;
      }

      handleCancel();
    } catch (e) {
      logger.error('upload error', e);
      updateCreditProgress(
        100,
        'error',
        `Upload failed - ${getUploadErrorMessage(e)}`
      );
      setMainAlert({
        showAlert: true,
        alertType: 'error',
        message: `File Creation Error - ${getUploadErrorMessage(e)}`
      });
    } finally {
      if (ws) {
        ws.close();
      }
      setUploadProcessing(false);
    }
  };

  const handleUploadFile = async () => {
    if (value.length === 0) return;

    type IndexedFile = { file: File; index: number };
    type PDFReadyFile = IndexedFile & { pageCount: number };
    type DOCXReadyFile = IndexedFile & { pageCount: number; key: string };

    const uploadErrors = Array.from({ length: value.length }, () => '');
    const failedFileNames: string[] = [];
    let successfulUploads = 0;
    let ws: WebSocket | null = null;

    const updateCreditProgress = (
      percent: number,
      status: CreditCheckStatus,
      message: string
    ) => {
      setCreditCheckProgress({ percent, status, message });
    };

    const updateFileProgress = (
      index: number,
      update: Partial<FileUploadProgressItem>
    ) => {
      setFileUploadProgressList((prev) =>
        prev.map((item, itemIndex) =>
          itemIndex === index ? { ...item, ...update } : item
        )
      );
    };

    const markFailure = (index: number, message: string) => {
      uploadErrors[index] = message;
      failedFileNames.push(value[index].name);
      updateFileProgress(index, {
        status: 'error',
        progress: 100,
        message
      });
    };

    try {
      setUploadProcessing(true);
      setUploadFileError([]);
      setShowUploadProgressPanel(true);
      setFileUploadProgressList(
        value.map(() => ({
          progress: 0,
          status: 'pending',
          message: 'Waiting for credit check'
        }))
      );
      updateCreditProgress(
        10,
        'in-progress',
        'Preparing files for credit check'
      );

      const docxFiles: IndexedFile[] = [];
      const pdfFiles: IndexedFile[] = [];
      const imageFiles: IndexedFile[] = [];

      for (let i = 0; i < value.length; i++) {
        if (fileTypeArray[i]?.mime === 'docx') {
          docxFiles.push({ file: value[i], index: i });
          continue;
        }
        if (fileTypeArray[i]?.mime === 'pdf') {
          pdfFiles.push({ file: value[i], index: i });
          continue;
        }
        if (
          fileTypeArray[i]?.mime === 'jpeg' ||
          fileTypeArray[i]?.mime === 'png'
        ) {
          imageFiles.push({ file: value[i], index: i });
          continue;
        }
        markFailure(i, 'Unsupported file type');
      }
      updateCreditProgress(25, 'in-progress', 'Calculating file metadata');

      const readyPDFs: PDFReadyFile[] = [];
      const readyDOCXs: DOCXReadyFile[] = [];
      let totalPageCount = imageFiles.length;

      for (const pdfFile of pdfFiles) {
        try {
          updateFileProgress(pdfFile.index, {
            status: 'in-progress',
            progress: 10,
            message: 'Reading PDF for credit check'
          });
          const pageCount = await getPDFPageCount(pdfFile.file);
          totalPageCount += pageCount;
          readyPDFs.push({ ...pdfFile, pageCount });
          updateFileProgress(pdfFile.index, {
            status: 'pending',
            progress: 20,
            message: 'Ready to upload after credit check'
          });
        } catch (e) {
          logger.error(`Failed to prepare PDF ${pdfFile.file.name}`, e);
          markFailure(
            pdfFile.index,
            `Failed to read PDF - ${getUploadErrorMessage(e)}`
          );
        }
      }

      if (docxFiles.length > 0) {
        updateCreditProgress(
          40,
          'in-progress',
          'Converting DOCX files for credit check'
        );
        try {
          ws = await createWSConnection(token);
          const connectionIdData = await waitForMessage(
            ws,
            (msg) => {
              return msg.type === 'connectionId';
            },
            300000
          );
          if (!connectionIdData?.connectionId) {
            throw Error('Websocket connection failed');
          }

          for (const docxFile of docxFiles) {
            try {
              updateFileProgress(docxFile.index, {
                status: 'in-progress',
                progress: 10,
                message: 'Converting DOCX for credit check'
              });
              const docxResult = await getDOCXPageCount(
                ws,
                docxFile.file,
                connectionIdData.connectionId,
                auth
              );
              const pageCount = Number(docxResult.data.pageCount);
              if (!Number.isFinite(pageCount) || pageCount <= 0) {
                throw Error('Invalid page count returned for DOCX');
              }
              totalPageCount += pageCount;
              readyDOCXs.push({
                ...docxFile,
                pageCount,
                key: docxResult.data.key
              });
              updateFileProgress(docxFile.index, {
                status: 'pending',
                progress: 20,
                message: 'Ready to upload after credit check'
              });
            } catch (e) {
              logger.error(`Failed to prepare DOCX ${docxFile.file.name}`, e);
              markFailure(
                docxFile.index,
                `Failed to convert DOCX - ${getUploadErrorMessage(e)}`
              );
            }
          }
        } catch (e) {
          logger.error('DOCX websocket setup failed', e);
          const wsError = `Failed to process DOCX - ${getUploadErrorMessage(e)}`;
          for (const docxFile of docxFiles) {
            markFailure(docxFile.index, wsError);
          }
        }
      }

      for (const imageFile of imageFiles) {
        updateFileProgress(imageFile.index, {
          status: 'pending',
          progress: 20,
          message: 'Ready to upload after credit check'
        });
      }
      updateCreditProgress(70, 'in-progress', 'Checking available credits');

      let enoughCredit = true;
      if (totalPageCount > 0) {
        const haveEnoughCredit = await axios.post(
          `${process.env.REACT_APP_KORU_API}/credit?type=verifyCreditHold`,
          {
            type: DOCTYPE.analysis,
            numberOfPages: totalPageCount
          },
          auth
        );
        enoughCredit =
          haveEnoughCredit?.data?.result?.message === 'Have Enough Credit';
      }

      if (!enoughCredit) {
        updateCreditProgress(
          100,
          'error',
          'Not enough credit to upload selected files'
        );
        setShowCoinsModal({ visible: true, type: 'BuyMore' });
        return;
      }
      updateCreditProgress(
        100,
        'success',
        'Credit check complete. Starting file uploads'
      );

      const uploadPdf = async (pdfFile: PDFReadyFile): Promise<boolean> => {
        try {
          updateFileProgress(pdfFile.index, {
            status: 'in-progress',
            progress: 35,
            message: 'Creating document record'
          });
          const docCreateResult = await axios.post(
            `${process.env.REACT_APP_KORU_API}/document?type=addNew`,
            {
              documentFileName: pdfFile.file.name,
              documentType: DOCTYPE.analysis,
              project: props.projectId,
              folder: props.folderId
            },
            auth
          );
          updateFileProgress(pdfFile.index, {
            status: 'in-progress',
            progress: 60,
            message: 'Applying credit hold'
          });
          await axios.post(
            `${process.env.REACT_APP_KORU_API}/credit?type=createCreditHold`,
            {
              type: DOCTYPE.analysis,
              numberOfPages: pdfFile.pageCount,
              documentId: docCreateResult.data.result._id
            },
            auth
          );
          updateFileProgress(pdfFile.index, {
            status: 'in-progress',
            progress: 80,
            message: 'Uploading PDF'
          });
          const presignedUrl = await axios.post(
            `${process.env.REACT_APP_KORU_API}/get-presigned-url?type=upload`,
            {
              documentId: `${docCreateResult.data.result._id}.pdf`
            },
            auth
          );
          await axios.put(presignedUrl.data.url, pdfFile.file, {
            headers: {
              'Content-Type': 'application/pdf'
            }
          });
          updateFileProgress(pdfFile.index, {
            status: 'success',
            progress: 100,
            message: 'Upload complete'
          });
          return true;
        } catch (e) {
          logger.error(`Failed to upload PDF ${pdfFile.file.name}`, e);
          markFailure(
            pdfFile.index,
            `Failed to upload PDF - ${getUploadErrorMessage(e)}`
          );
          return false;
        }
      };

      const uploadDocx = async (docxFile: DOCXReadyFile): Promise<boolean> => {
        try {
          updateFileProgress(docxFile.index, {
            status: 'in-progress',
            progress: 35,
            message: 'Creating document record'
          });
          const docCreateResult = await axios.post(
            `${process.env.REACT_APP_KORU_API}/document?type=addNew`,
            {
              documentFileName: docxFile.file.name,
              documentType: DOCTYPE.analysis,
              project: props.projectId,
              folder: props.folderId
            },
            auth
          );
          updateFileProgress(docxFile.index, {
            status: 'in-progress',
            progress: 60,
            message: 'Applying credit hold'
          });
          await axios.post(
            `${process.env.REACT_APP_KORU_API}/credit?type=createCreditHold`,
            {
              type: DOCTYPE.analysis,
              numberOfPages: docxFile.pageCount,
              documentId: docCreateResult.data.result._id
            },
            auth
          );
          updateFileProgress(docxFile.index, {
            status: 'in-progress',
            progress: 80,
            message: 'Moving converted DOCX output'
          });
          await axios.post(
            `${process.env.REACT_APP_KORU_API}/document?type=moveConvertedFile`,
            {
              documentId: `${docCreateResult.data.result._id}.pdf`,
              key: docxFile.key
            },
            auth
          );
          updateFileProgress(docxFile.index, {
            status: 'success',
            progress: 100,
            message: 'Upload complete'
          });
          return true;
        } catch (e) {
          logger.error(`Failed to upload DOCX ${docxFile.file.name}`, e);
          markFailure(
            docxFile.index,
            `Failed to upload DOCX - ${getUploadErrorMessage(e)}`
          );
          return false;
        }
      };

      const uploadImage = async (imageFile: IndexedFile): Promise<boolean> => {
        try {
          updateFileProgress(imageFile.index, {
            status: 'in-progress',
            progress: 35,
            message: 'Creating document record'
          });
          const ext = await detectFileType(imageFile.file);
          if (!ext?.ext || !ext?.mime) {
            throw Error('Unsupported image format');
          }
          const docCreateResult = await axios.post(
            `${process.env.REACT_APP_KORU_API}/document?type=addNew`,
            {
              documentFileName: imageFile.file.name,
              documentType: DOCTYPE.analysis,
              project: props.projectId,
              folder: props.folderId,
              fileExt: ext.ext
            },
            auth
          );
          updateFileProgress(imageFile.index, {
            status: 'in-progress',
            progress: 60,
            message: 'Applying credit hold'
          });
          await axios.post(
            `${process.env.REACT_APP_KORU_API}/credit?type=createCreditHold`,
            {
              type: DOCTYPE.analysis,
              numberOfPages: 1,
              documentId: docCreateResult.data.result._id
            },
            auth
          );
          updateFileProgress(imageFile.index, {
            status: 'in-progress',
            progress: 80,
            message: 'Uploading image'
          });
          const presignedUrl = await axios.post(
            `${process.env.REACT_APP_KORU_API}/get-presigned-url?type=uploadImage&ext=${ext.ext}`,
            {
              documentId: `${docCreateResult.data.result._id}`
            },
            auth
          );
          await axios.put(presignedUrl.data.url, imageFile.file, {
            headers: {
              'Content-Type': ext.mime
            }
          });
          updateFileProgress(imageFile.index, {
            status: 'success',
            progress: 100,
            message: 'Upload complete'
          });
          return true;
        } catch (e) {
          logger.error(`Failed to upload image ${imageFile.file.name}`, e);
          markFailure(
            imageFile.index,
            `Failed to upload image - ${getUploadErrorMessage(e)}`
          );
          return false;
        }
      };

      const uploadTasks: Promise<boolean>[] = [
        ...readyPDFs.map((pdfFile) => uploadPdf(pdfFile)),
        ...readyDOCXs.map((docxFile) => uploadDocx(docxFile)),
        ...imageFiles.map((imageFile) => uploadImage(imageFile))
      ];
      const uploadResults = await Promise.all(uploadTasks);
      successfulUploads = uploadResults.filter(Boolean).length;

      if (successfulUploads > 0) {
        getAllDocs();
      }

      if (failedFileNames.length > 0) {
        const uniqueFailedFileNames = Array.from(new Set(failedFileNames));
        setUploadFileError(uploadErrors);
        setMainAlert({
          showAlert: true,
          alertType: 'error',
          message:
            successfulUploads > 0
              ? `${successfulUploads} file(s) uploaded. Failed file(s): ${uniqueFailedFileNames.join(
                  ', '
                )}`
              : `No files uploaded. Failed file(s): ${uniqueFailedFileNames.join(
                  ', '
                )}`
        });
        return;
      }

      handleCancel();
    } catch (e) {
      logger.error('upload error', e);
      updateCreditProgress(
        100,
        'error',
        `Upload failed - ${getUploadErrorMessage(e)}`
      );
      setMainAlert({
        showAlert: true,
        alertType: 'error',
        message: `File Creation Error - ${getUploadErrorMessage(e)}`
      });
    } finally {
      if (ws) {
        ws.close();
      }
      setUploadProcessing(false);
    }
  };

  const handlePolicyFileUpload = async () => {
    if (value.length === 0) return;
    if (props.type === DOCTYPE.contract && !selectedPolicy?.value) {
      setAlert('Select a policy before uploading a contract.', 'error', 4);
      return;
    }
    setUploadProcessing(true);
    let ws: WebSocket | null = null;
    try {
      const docType =
        props.type === DOCTYPE.policy_document
          ? DOCTYPE.policy_document
          : DOCTYPE.contract;
      const currentFile = value[0];
      const fileType = await detectFileType(currentFile);

      if (!fileType) {
        throw new Error(`Unsupported file type for ${currentFile.name}`);
      }

      const documentCreateOverrides =
        props.type === DOCTYPE.contract
          ? { policyId: selectedPolicy?.value }
          : undefined;

      if (fileType.mime === 'pdf') {
        const docCreateResult = await axios.post(
          `${process.env.REACT_APP_KORU_API}/document?type=addNew`,
          {
            documentFileName: currentFile.name,
            documentType: docType,
            project: props.projectId,
            folder: props.folderId,
            fileExt: fileType.ext,
            ...documentCreateOverrides
          },
          auth
        );
        const presignedUrl = await axios.post(
          `${process.env.REACT_APP_KORU_API}/get-presigned-url?type=uploadPolicyPdf`,
          {
            documentId: `${docCreateResult.data.result._id}`
          },
          auth
        );
        const putResult = await axios.put(presignedUrl.data.url, currentFile, {
          headers: {
            'Content-Type': 'application/pdf'
          }
        });
        console.log('put file result', putResult);
      } else if (fileType.mime === 'docx') {
        ws = await createWSConnection(token);
        const connectionIdData = await waitForMessage(
          ws,
          (msg) => msg.type === 'connectionId',
          300000
        );

        if (!connectionIdData?.connectionId) {
          throw new Error('Websocket connection failed');
        }

        const docxResult = await getDOCXPageCount(
          ws,
          currentFile,
          connectionIdData.connectionId,
          auth
        );
        const uploadResult = await uploadDocxFile({
          file: currentFile,
          index: 0,
          fileExt: fileType.ext,
          documentType: docType,
          convertedFileKey: docxResult?.data?.key,
          documentCreateOverrides
        });

        if (!uploadResult.success) {
          throw new Error(uploadResult.error);
        }
      } else {
        throw new Error(`Unsupported file type for ${currentFile.name}`);
      }

      handleCancel();
      getAllDocs();
    } catch (e) {
      setAlert(getUploadErrorMessage(e), 'error', 4);
    } finally {
      if (ws) {
        ws.close();
      }
      setUploadProcessing(false);
    }
  };
  useEffect(() => {
    if (value.length > 0 && fileError.length === 0 && props.projectId) {
      setAllowUpload(true);
    } else {
      setAllowUpload(false);
    }
  }, [value, fileError]);

  const uploadButtonDisabled = useMemo((): boolean => {
    let returnValue = true;
    const errors = fileError.some((ele) => ele !== '');
    if (props.type === DOCTYPE.questionnaire) {
      if (value.length > 0 && !errors) {
        return false;
      }
    }
    if (props.type === DOCTYPE.analysis) {
      if (value.length > 0 && !errors) {
        return false;
      }
    }
    if (props.type === DOCTYPE.prevRfp) {
      if (value.length > 0 && !errors) {
        return false;
      }
    }
    if (
      props.type === DOCTYPE.policy_document ||
      props.type === DOCTYPE.contract
    ) {
      if (
        value.length === 1 &&
        !errors &&
        (props.type !== DOCTYPE.contract || Boolean(selectedPolicy?.value))
      ) {
        return false;
      }
    }
    return returnValue;
  }, [fileError, props.type, selectedPolicy?.value, value.length]);
  const uploadModeLabel = useMemo(() => {
    if (props.type === DOCTYPE.questionnaire) {
      return 'Questionnaire Upload';
    }
    if (props.type === DOCTYPE.prevRfp) {
      return 'Previous RFP Library';
    }
    if (props.type === DOCTYPE.policy_document) {
      return 'Policy Document';
    }
    if (props.type === DOCTYPE.contract) {
      return 'Contract';
    }
    return 'Analysis Upload';
  }, [props.type]);
  const uploadModeDescription = useMemo(() => {
    if (props.type === DOCTYPE.questionnaire) {
      return 'Drop your questionnaire file to parse and verify before processing.';
    }
    if (props.type === DOCTYPE.prevRfp) {
      return 'Upload prior RFP files, view extracted questions / answers, publish to library.';
    }
    return 'Upload supported files to prepare them for analysis.';
  }, [props.type]);

  return (
    <div className="relative overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-[0_24px_80px_-36px_rgba(15,23,42,0.65)]">
      <div className="pointer-events-none absolute -right-14 -top-14 h-44 w-44 rounded-full bg-emerald-200/45 blur-3xl" />
      <div className="pointer-events-none absolute -left-20 bottom-0 h-52 w-52 rounded-full bg-sky-200/35 blur-3xl" />
      <p>{props.type}</p>
      <div className="relative z-10 p-5 sm:p-8">
        <div className="mb-6 flex flex-col gap-4 border-b border-slate-200 pb-6 lg:flex-row lg:items-start lg:justify-between">
          <div className="space-y-2">
            <p className="inline-flex rounded-full border border-emerald-200 bg-emerald-50 px-3 py-1 text-xs font-semibold uppercase tracking-[0.08em] text-emerald-700">
              {uploadModeLabel}
            </p>
            <h2 className="text-xl font-semibold text-slate-900 sm:text-2xl">
              Upload Documents
            </h2>
            <p className="max-w-2xl text-sm text-slate-600">
              {uploadModeDescription}
            </p>

            {props.type === DOCTYPE.contract && (
              <FormField label="Select Policy">
                <Select
                  selectedOption={selectedPolicy}
                  options={policyOptions}
                  placeholder="Choose a policy"
                  empty="No policies available"
                  onChange={({ detail }) =>
                    setSelectedPolicy(
                      detail.selectedOption.value
                        ? {
                            label: detail.selectedOption.label || '',
                            value: detail.selectedOption.value
                          }
                        : null
                    )
                  }
                />
              </FormField>
            )}
          </div>
          <div className="flex flex-col items-center gap-2">
            {props.type === DOCTYPE.questionnaire &&
              value.length === 1 &&
              determinedFileType?.mime === 'sheet' && (
                <Button
                  disabled={!allowUpload}
                  loading={uploadProcessing}
                  onClick={() => handleRFPUpload(true)}
                >
                  Upload & Verify
                </Button>
              )}
            <Button
              disabled={uploadButtonDisabled}
              loading={uploadProcessing}
              onClick={() => {
                switch (true) {
                  case props.type === DOCTYPE.questionnaire:
                    handleRFPUpload();
                    break;
                  case props.type === DOCTYPE.analysis:
                    handleUploadFile();
                    break;
                  case props.type === DOCTYPE.prevRfp:
                    handleUploadFilePrev_RFP_All();
                    break;
                  case props.type === DOCTYPE.policy_document ||
                    props.type === DOCTYPE.contract:
                    handlePolicyFileUpload();
                    break;
                }
              }}
            >
              Upload Documents
            </Button>
            <Button onClick={() => handleCancel()}>Cancel</Button>
          </div>
        </div>

        <FormField>
          {!docProcessing ? (
            <div className="space-y-4">
              {props.type === DOCTYPE.questionnaire && (
                <FileUpload
                  onChange={({ detail }) => {
                    handleInputChange(detail.value);
                  }}
                  value={value}
                  i18nStrings={{
                    uploadButtonText: (e) => 'Drag File or Click to upload',
                    dropzoneText: (e) => 'Drop file to upload',
                    removeFileAriaLabel: (e) => `Remove file ${e + 1}`,
                    limitShowFewer: 'Show fewer files',
                    limitShowMore: 'Show more files',
                    errorIconAriaLabel: 'Error'
                  }}
                  showFileLastModified
                  showFileSize
                  showFileThumbnail
                  tokenLimit={3}
                  constraintText={'.xlsx, .xls, .pdf, .docx'}
                  multiple={true}
                  accept={'.xlsx, .xls, .pdf, .docx'}
                  fileErrors={combinedFileErrors}
                />
              )}
              {(props.type === DOCTYPE.policy_document ||
                props.type === DOCTYPE.contract) && (
                <FileUpload
                  onChange={({ detail }) => {
                    handleInputChange(detail.value);
                  }}
                  value={value}
                  i18nStrings={{
                    uploadButtonText: (e) => 'Drag File or Click to upload',
                    dropzoneText: (e) => 'Drop file to upload',
                    removeFileAriaLabel: (e) => `Remove file ${e + 1}`,
                    limitShowFewer: 'Show fewer files',
                    limitShowMore: 'Show more files',
                    errorIconAriaLabel: 'Error'
                  }}
                  showFileLastModified
                  showFileSize
                  showFileThumbnail
                  tokenLimit={3}
                  constraintText={'.pdf, .docx'}
                  multiple={true}
                  accept={'.pdf, .docx'}
                  fileErrors={combinedFileErrors}
                />
              )}
              {props.type === DOCTYPE.prevRfp && (
                <FileUpload
                  onChange={({ detail }) => {
                    handleInputChange(detail.value);
                  }}
                  value={value}
                  i18nStrings={{
                    uploadButtonText: (e) => 'Drag File or Click to upload',
                    dropzoneText: (e) => 'Drop file to upload',
                    removeFileAriaLabel: (e) => `Remove file ${e + 1}`,
                    limitShowFewer: 'Show fewer files',
                    limitShowMore: 'Show more files',
                    errorIconAriaLabel: 'Error'
                  }}
                  showFileLastModified
                  showFileSize
                  showFileThumbnail
                  tokenLimit={3}
                  constraintText={'accepts .xlsx .xls .pdf .docx'}
                  multiple={true}
                  accept={'.xlsx, .xls, .pdf, .docx'}
                  fileErrors={combinedFileErrors}
                />
              )}
              {props.type === DOCTYPE.analysis && (
                <FileUpload
                  onChange={({ detail }) => {
                    handleInputChange(detail.value);
                  }}
                  value={value}
                  i18nStrings={{
                    uploadButtonText: (e) => 'Drag Files or Click to upload',
                    dropzoneText: (e) => 'Drop files to upload',
                    removeFileAriaLabel: (e) => `Remove file ${e + 1}`,
                    limitShowFewer: 'Show fewer files',
                    limitShowMore: 'Show more files',
                    errorIconAriaLabel: 'Error'
                  }}
                  showFileLastModified
                  showFileSize
                  showFileThumbnail
                  tokenLimit={3}
                  constraintText={'Supported Formats: PDF, DOCX, PNG, JPEG'}
                  multiple={true}
                  accept={'.pdf, .docx, .jpeg, .png'}
                  fileErrors={combinedFileErrors}
                />
              )}
              {(props.type === DOCTYPE.prevRfp ||
                props.type === DOCTYPE.analysis ||
                props.type === DOCTYPE.questionnaire) &&
                showUploadProgressPanel &&
                fileUploadProgressList.length > 0 && (
                  <div className="space-y-4 rounded-2xl border border-slate-200 bg-slate-50/70 p-4">
                    <ProgressBar
                      label="Step 1: Checking available credit"
                      status={
                        creditCheckProgress.status === 'success'
                          ? 'success'
                          : creditCheckProgress.status === 'error'
                            ? 'error'
                            : 'in-progress'
                      }
                      value={creditCheckProgress.percent}
                      description={creditCheckProgress.message}
                      resultText={
                        creditCheckProgress.status === 'success'
                          ? 'Credit check complete'
                          : creditCheckProgress.status === 'error'
                            ? 'Credit check failed'
                            : undefined
                      }
                    />
                    <p className="text-sm font-medium text-slate-700">
                      Step 2: Uploading files
                    </p>
                    {value.map((file, index) => {
                      const fileProgress = fileUploadProgressList[index];
                      if (!fileProgress) return null;
                      return (
                        <ProgressBar
                          key={`${file.name}-${index}-${file.lastModified}`}
                          label={file.name}
                          status={
                            fileProgress.status === 'success'
                              ? 'success'
                              : fileProgress.status === 'error'
                                ? 'error'
                                : 'in-progress'
                          }
                          value={fileProgress.progress}
                          description={fileProgress.message}
                          resultText={
                            fileProgress.status === 'success'
                              ? 'Upload complete'
                              : fileProgress.status === 'error'
                                ? 'Upload failed'
                                : undefined
                          }
                        />
                      );
                    })}
                  </div>
                )}
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center gap-3 rounded-2xl border border-slate-200 bg-slate-50/90 py-12">
              <Spinner size="large" />
              <p className="text-sm font-medium text-slate-700">
                Processing document for upload
              </p>
            </div>
          )}
        </FormField>
      </div>
      <Modal
        visible={showCoinsModal.visible}
        onDismiss={() => setShowCoinsModal({ visible: false, type: '' })}
      >
        <>
          {showCoinsModal.type === 'BuyMore' ? (
            <div>
              <p className="text-sm text-gray-700 mb-4">
                You do not have enough Compliance Credits to perform this
                document analysis. To continue using advanced features like
                document analysis and AI answers, additional credits are
                required.
              </p>
              {user?.isAdmin ? (
                <Button
                  onClick={() => {
                    setShowCoinsModal({ visible: false, type: '' });
                    setSubsAlert('', 'coins');
                  }}
                  // className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded"
                >
                  Buy More Credits
                </Button>
              ) : (
                <button
                  className="bg-gray-400 text-white font-medium py-2 px-4 rounded cursor-not-allowed"
                  disabled
                >
                  Contact your administrator to purchase more credits
                </button>
              )}
            </div>
          ) : null}
          {showCoinsModal.type === 'Warning' ? (
            <div>
              <p className="text-sm text-gray-700 mb-4">
                You are running low on compliance credits. To continue using
                advanced features like document analysis and AI answers, we
                suggest buying additional coins to prevent interruptions.
              </p>
              {user?.isAdmin ? (
                <p className="text-sm text-gray-700 mb-4">
                  Navigate to the "View Credit Usage" page to purchase more.
                </p>
              ) : (
                <p className="text-sm text-gray-700 mb-4">
                  Contact you administrator to have them purchase more.
                </p>
              )}
            </div>
          ) : null}
        </>
      </Modal>
      {uploadProcessing && props.type === DOCTYPE.questionnaire && (
        <KoruLoading centerText={uploadProgressText} />
      )}
    </div>
  );
};
